export default {
  marketplace: "Marketplace",
  subCategory: "Sub-category",
};
